import { useEffect } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { useSellerWallets } from '../../hooks/use-seller-wallets';
import { getAllWalletSettings } from '../utilities/api';
import equals from 'react-fast-compare';

const initialSettingsMap = {};

export const useWalletSettingsMap = () => {
  const wallets = useSellerWallets();
  const [loading, setLoading] = useAsyncSafeState(false);
  const [settingsMap, setSettingsMap] = useAsyncSafeState(initialSettingsMap);

  useEffect(() => {
    if (!wallets?.length) {
      return;
    }
    setLoading(true);
    const load = async () => {
      try {
        const settingsData = await getAllWalletSettings();
        const proposedSettingsMap = settingsData.reduce(
          (acc, s) => ({
            ...acc,
            [s.walletId]: s,
          }),
          {},
        );
        setSettingsMap((prevSettingsMap) => {
          return equals(prevSettingsMap, proposedSettingsMap) ? prevSettingsMap : proposedSettingsMap;
        });
      } catch {
        setSettingsMap(initialSettingsMap);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [
    wallets?.length, // though unused directly, wallets are in the dependency array so we get a fresh list if a new wallet is added
    setLoading,
    setSettingsMap,
  ]);

  return {
    loading,
    settingsMap,
  };
};
